// 아래 위키의 webview interface를 호출합니다.
// https://confluence.tde.sktelecom.com/pages/viewpage.action?pageId=88554927
// 모든 함수를 wrapping하고 있지 않으며, 추가적으로 필요한 함수는 추가되어야 합니다.

import throttle from 'lodash/throttle'

interface nativeInterfaceParams {
  [key: string]: any
}

// param = {
//     message: string,
//     content: string,
//     okCallback: string,
//     cancelCallback: string,
//     cancelText: string,
//     okText: string,
//     cancelable: bool
// };
export const nativeShowPopup = (params: nativeInterfaceParams): void => {
  executeNativeInterface('showPopup', params)
}

// param = {
//     message: string
// };
export const nativeShowToast = (params: nativeInterfaceParams): void => {
  executeNativeInterface('showToast', params)
}

export const nativeCloseWindow = (params: nativeInterfaceParams) => {
  executeNativeInterface('closeWindow', params)
}

// 새 화면 띄우기
// {
//     urlPath: "/v2/baseball/intro.html"
// };
export const nativeOpenWindow = (params: nativeInterfaceParams): void => {
  executeNativeInterface('openWindow', params)
}

// 새 화면 띄우기 (외부 URL)
// {
//     urlPath: string
// };
export const nativeOpenExternalWindow = (params: nativeInterfaceParams): void => {
  executeNativeInterface('openExternalWindow', params)
}

// 기본 브라우저 열기
// {
//     url: string
// };
export const nativeOpenBrowser = (params: nativeInterfaceParams): void => {
  executeNativeInterface('openBrowser', params)
}

// InApp Browser 열기
// {
//     url: string
// };
export const nativeOpenInAppBrowser = (params: nativeInterfaceParams): void => {
  executeNativeInterface('openInAppBrowser', params)
}

// 툴바 고정
// {
//     fixed: bool
// };
export const nativeFixedToolBar = (params: nativeInterfaceParams): void => {
  executeNativeInterface('fixedToolBar', params)
}

// navigation bar 숨기기 : title 부분 숨길 때 사용
// {
//     hidden: bool
// };
export const nativeNavigationBarHidden = (params: nativeInterfaceParams): void => {
  executeNativeInterface('navigationBarHidden', params)
}

// 로그 아웃 요청
export const nativeLogout = (): void => {
  executeNativeInterface('logout', {})
}

// userId요청
export const nativeRequestUserId = (): void => {
  executeNativeInterface('requestUserId', {})
}

// haptic
export const nativeHaptic = (params?: nativeInterfaceParams): void => {
  const defaultParams = { effect: osUtils.isAndroid ? 'tick' : 'click' }
  executeNativeInterface('haptic', params || defaultParams)
}

// image download
export const nativeSaveImage = (params: nativeInterfaceParams): void => {
  executeNativeInterface('saveImage', params)
}

// APOLLOQA-21005: 스로틀 적용 haptic 함수
export const throttledNativeHaptic = throttle(nativeHaptic, 100)

// click log 남기기 용도 - 아래 값들은 정해진 클릭코드값을 상황에 따라 넣으면 됩니다.
// 1. pageview
// {
//     type: "PageView",
//     pageCode: "event.detail"
// }
// 2. click log
// {
//     type: 'Click',
//     pageCode: PAGECODE_BASEBALL_INFO,
//     clickCode: 'confirm',
//     clickActionCode: TAP
// }
// 3. additional dimension이 포함된 경우
// {
//     type: 'Click',
//     pageCode: 'event.detail',
//     clickCode: 'button',
//     clickActionCode: 'TAP',
//     additionalDimensions: [{
//         DIMENSION_CD: "POST_ID",
//         DIMENSION_VALUE: id
//     }, {
//         DIMENSION_CD: "BUTTON_CD",
//         DIMENSION_VALUE: data?.buttoncd
//     }]
// }
export const nativeSendLog = (params: nativeInterfaceParams): void => {
  executeNativeInterface('sendLog', params)
}

// 편리를 위해 추가됨 pageview log를 남기기 위한 함수
export const nativeSendPageViewLog = (pageCode: string, additionalDimensions?: object): void => {
  nativeSendLog({
    type: 'PageView',
    pageCode,
    additionalDimensions
  })
}

export const nativeRequestIdp = (reqType: string, reqUri: string): void => {
  const params = {
    socialType: reqType,
    uri: reqUri
  }
  executeNativeInterface('requestIdp', params)
}

// 사이드드로어
export const nativeSideDrawer = (params: nativeInterfaceParams): void => {
  executeNativeInterface('sideDrawer', params)
}

export const nativeSetAppStorageItem = (params: nativeInterfaceParams): void => {
  executeNativeInterface('setAppStorageItem', params)
}

export const nativeRequestAppStorageItem = (params: nativeInterfaceParams): void => {
  executeNativeInterface('requestAppStorageItem', params)
}

/**
 * 로그인 킷 전용
 * T 전화로 부터 데이터를 전달 받는다
 * https://confluence.tde.sktelecom.com/pages/viewpage.action?pageId=455565393
 */
export const nativeRequestAdditionalData = (): void => {
  executeNativeInterface('requestAdditionalData', {})
}

export function executeNativeInterface(method: string, params: nativeInterfaceParams): void {
  if (window?.ApolloWebCommonHandler) {
    // means android
    window?.ApolloWebCommonHandler?.[method]?.(JSON.stringify(params))
  } else if (window?.webkit?.messageHandlers) {
    // means ios
    window?.webkit?.messageHandlers?.[method]?.postMessage?.(params)
  } else {
    // means local
    console.log('executeNativeInterface:', method, params)
  }
}

// 탈퇴 요청
export const nativeRequestRevoke = (): void => {
  executeNativeInterface('requestRevoke', {})
}

// Firebase Performance Send
export const nativeSendPerformanceTracker = (actionType: string, traceName: string): void => {
  const params = {
    actionType,
    traceName: `_${isStg() ? 'stg' : 'prd'}/${traceName}_open`
  }
  executeNativeInterface('sendPerformanceTracker', params)
}

// 안드로이드 공유
// {
//     url: string
// };
export const nativeOpenShare = (url: string): void => {
  const params = { url }
  executeNativeInterface('share', params)
}
